import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import MaatwerkHeader from "./MaatwerkHeader";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import "./MaatwerkLayout.css";
import MaatwerkFooter from "./MaatwerkFooter";


const MaatwerkLayout = ({ company }) => {
  const theme = useTheme();
  const location = useLocation();

  const [isStuck, setIsStuck] = useState(false);

  const isListingPage = location.pathname.includes("listings");

  function resultsView() {
    return location.pathname.includes("results");
  }

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 70) {
        setIsStuck(true);
      } else {
        setIsStuck(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Media queries
  const mobile = useMediaQuery(theme.breakpoints.between("mobile", "ipad"));
  const tablet = useMediaQuery(theme.breakpoints.between("ipad", "laptop"));
  const laptop = useMediaQuery(theme.breakpoints.up("laptop"));

 
  return (
    <React.Fragment>

      {/* MOBILE */}
      {mobile && (
        <div>
          {/* Header */}
          <MaatwerkHeader company={company}/>

          {/* Outlet */}
          <div id="m-main">
            <div className="m-main-content">
              <Outlet />
            </div>
          </div>
          {/* Footer */}
          <div id="m-footer">
            <MaatwerkFooter />
          </div>
        </div>
      )}

      {/* TABLET */}
      {tablet && (
        <div>
          {/* Header */}
          <MaatwerkHeader company={company}/>

          {/* Outlet */}
          <div id="t-main">
            <div className="t-main-content">
              <Outlet />
            </div>
          </div>

          {/* Footer */}
          <div id="t-footer">
            <MaatwerkFooter />
          </div>
        </div>
      )}

      {/* LAPTOP */}
      {laptop && (
        <div id="maatwerk-container">
          {/* Header */}
          <header
            className={`d-header has-sticky sticky-jump  `}
            style={{
              height: isStuck ? "95px" : "",
            }}
          >
            <div
              id="d-header-wrapper"
              className={`d-header-wrapper ${isStuck ? "stuck" : ""}
                  ${resultsView() ? "results-header" : ""}
                  `}
            >
              <MaatwerkHeader company={company}/>
            </div>
          </header>

          {/* Outlet */}
          <div id="d-main" >
            <div
              className={`d-main-content ${
                resultsView() ? "results-page" : ""
              } ${
                isListingPage ? "listings-page" : ""
              }`}
            >
              <Outlet />
            </div>
          </div>

          {/* Footer */}
          <div
            id="d-footer"
            className={`${resultsView() ? "results-footer" : ""}`}
          >
            <MaatwerkFooter />
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
export default MaatwerkLayout;
